export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#023858',
      gradientDefault2: '#0184A4',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: '/images/logopadrao.png',
  favicon: '/faviconpadrao.png',
}

export const seo = {
  titulo: 'Certificadora Padrão',
  palavrasChave:
    'Certificado Digital em curitiba, Certificado Digital no centro de curitiba, Onde emitir certificado digital em curitiba, Certificado Digital para nota fiscal em curitiba ,Como emitir ecpf em curitiba , Como emitir ecnpj em curitiba ,Certificado emédico em curitiba ,Assinatura eletronica em curitiba,Certificado digital com padrão de qualidade em curitiba,Preço de Certificado Digital,Onde comprar certificado digital em curitiba,Emitir certificado digital em curitiba,Certificado Digital A3,Certificado Digital A1',
  descricao:
    'Fazemos parte de uma das maiores redes de emissão de Certificado Digital, trazendo segurança e conforto para todos os nossos clientes, procurando sempre oferecer-lhes um portfólio de soluções abrangentes e adequadas aos seus negócios.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: true,
  darkMode: true,
  contaLogin: true,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
}

export const footer = {
  is0800: false,
  telefone: '4197853322',
  whatsapp: '4197853322',
  botaoWhatsapp: '4197853322',
  number0800: '0800 600 2710',
  titulo: 'Certificado digital em Curitiba',
  cidadeuf: 'Curitiba/PR',
  cidade: 'Curitiba',
  bairro: 'Centro',
  rua: 'Avenida Visconde de Guarapuava',
  numero: '2764',
  complemento: 'sl.405',
  cep: '80010-100',
  cnpj: '35.646.780/0001-26',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/Certificadora-Padrao/',
  instagram: 'https://www.instagram.com/certificadorapadrao/',
  linkedin:
    'https://www.linkedin.com/company/certificadora-padr%C3%A3o/?originalSubdomain=br',
}

export const digisac = {
  id: 'abea16a7-8cc0-40e2-9af5-16e5bbe538f7',
  status: true,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
